module.exports = "0x467B0C9560141f950c69eb771B20A6dC8Dc115dD"


// WEBPACK FOOTER //
// ./src/contracts/SlammerTime.1.address.js